/******************************************************************
product.js :
This js file contains js funtions use in product.html
******************************************************************/

"use strict";

var productPage = (function ($) {
  var productCategory = getProductInfoFromURL().productCategory;
  var product = getProductInfoFromURL().product;
  var productVersion = getProductInfoFromURL().productVersion;
  var productLanguage = getProductInfoFromURL().productLanguage;
  var topicKey = getProductInfoFromURL().topicKey;
  var productName;
  var productCoveoID;
  var productVersions; //list all supported version in obj form
  var productJson;
  var tocJson;
  var isOnePageEnabled = false;

  function getProductInfoFromURL() {
    var urlHash =
      urlControl.getURLParameter("tpid") ||
      window.location.hash.substring(1) ||
      window.location.search.substring(1);
    return {
      productCategory: urlHash.split("/")[0],
      product: urlHash.split("/")[1],
      productVersion: urlHash.split("/")[2],
      productLanguage: urlHash.split("/")[3],
      topicKey: urlHash.split("/")[4],
    };
  }

  function setProductInfoFromURL() {
    product = getProductInfoFromURL().product;
    productVersion = getProductInfoFromURL().productVersion;
    productLanguage = getProductInfoFromURL().productLanguage;
    topicKey = getProductInfoFromURL().topicKey;
  }

  function getProductInfo() {
    return {
      product: product,
      productVersion: productVersion,
      productLanguage: productLanguage,
      topicKey: topicKey,
    };
  }

  function refreshProductPage() {
    window.location.reload();
  }

  function redirectPage() {
    window.location.replace("error.html" + "?lang=" + productLanguage); //404
  }

  function pageInfo() {
    function setPageInfo(title, shortDescription) {
      title = title !== productName ? title + " | " : "";
      var version = uniqVersion.isUniqVersion(productVersion)
        ? localizePage.getLocalizedString(
            "common:uniqVersion:" + uniqVersion.getUniqHook(productVersion)
          )
        : productVersion;

      var brandInTitle;
      var brandInMeta;
      brandInTitle = " | F-Secure User Guides";
      brandInMeta = "F-Secure ";
      if (product == "internet-security" || product == "anti-virus") {
        $("#ws-address-alert").replaceWith(
          '<div id="fs-eol-notice" class="alert-version"><div class="alert-container"><span class="fsg-icon icon-status-warning"></span><span data-localize="isavEndOfLife"></span></div></div>'
        );
        localizePage.localize("product:isavEndOfLife");
      }

      document.title = title + productName + " | " + version + brandInTitle;
      $('meta[name="description"]').attr(
        "content",
        brandInMeta + productName + " : " + shortDescription
      ); 
      if (document.querySelector("html").lang!==productLanguage){
        document.querySelector("html").lang=productLanguage
      } 
    }

    function updateProductName(prodName) {
      var title = document.title.split(" | ");
      var firstTitle = title[0];
      title = firstTitle === prodName ? _(title).without(prodName) : title;
      title = title.join(" | ").replace("undefined", prodName);
      document.title = title;
      var newDesc = $('meta[name="description"]')
        .attr("content")
        .replace("undefined", prodName);
      $('meta[name="description"]').attr("content", newDesc);
    }

    return {
      setPageInfo: setPageInfo,
      updateProductName: updateProductName,
    };
  }

  function enabledOnePageView(key) {
    isOnePageEnabled = true;
    mainContent.pageContentAll.enabledScrollSpy();
    mainContent.pageSubtopics.hide();
    mainContent.pageRelatedtopics.hide();
    mainContent.pagePopulartopics.hide();
    sidebar.highlightMenuItem(key);
    loadContent(key, 1);
  }

  function disabledOnePageView(isWithReload) {
    isWithReload = false || isWithReload;
    isOnePageEnabled = false;
    if (isWithReload) {
      var prodInfo = getProductInfoFromURL();
      var currentTopicKey;

      try {
        var supportedLangs = _(productVersions).find(function (obj) {
          return obj.number === productVersion;
        });
        currentTopicKey = stripVersionAndLanguage(
          prodInfo.topicKey,
          supportedLangs
        );
        currentTopicKey = currentTopicKey
          ? currentTopicKey + "-" + productVersion + "-" + productLanguage
          : null;
      } catch (err) {
        currentTopicKey = null;
      }

      if (currentTopicKey) {
        loadContent(currentTopicKey);
      } else {
        loadContent(tocJson[0]);
      }
    } else {
      midBar.onePageViewToggle.switchOff();
    }
    mainContent.pageContentAll.disabledScrollSpy();
  }

  function isOnePageViewEnabled() {
    return isOnePageEnabled;
  }

  function loadContent(key, loadAll, loadFromBrowserHistory) {
    function find(object, id) {
      if (_(object).isObject()) {
        if (id in object) {
          return object;
        }
        for (var k in object) {
          var found = find(object[k], id);
          if (found) {
            return found;
          }
        }
      }
    }

    function createSubTopics(tocJson, key) {
      function createSubTopic(data, index, list) {
        var subTopicKey = _(data).isObject() ? _(data).keys() : data;

        //DCX-382
        var subTopic = "data/" + product + "/" + subTopicKey + ".json";
        $.getJSON(subTopic).done(function (data) {
          var shortdesc;
          for (key in data) {
            if (key.match(/^shortdesc_/)) shortdesc = data[key];
          }
          if (typeof shortdesc !== "undefined") {
            var getSubTopiclist = mainContent.pageSubtopics.getObj();
            $(getSubTopiclist)
              .find("[data-key='" + subTopicKey + "']")
              .after("<br><span>" + shortdesc + "</span>");
          }
        });
        listItems +=
          "<li><a href='" +
          linkBuilder.build(subTopicKey) +
          "' data-key='" +
          subTopicKey +
          "'>" +
          productJson[subTopicKey] +
          "</a></li>";
      }

      var subtopics = _.chain(find(tocJson, key))
        .filter(function (e) {
          return _(e).isObject();
        })
        .values()
        .first()
        .value();

      var listItems = "";
      //console.time("subtopics")
      _(subtopics).each(createSubTopic);
      //console.timeEnd("subtopics")
      mainContent.pageSubtopics.addItems($(listItems));
      mainContent.pageSubtopics.getObj().toggleClass("show", !!subtopics); // show only if subtopics available and except frontpage
    }

    function createRelatedTopics(json, key) {
      function createRelatedTopic(key) {
        //DCX-382
        var relatedTopic = "data/" + product + "/" + key + ".json";
        var mainTopic = key;

        $.getJSON(relatedTopic).done(function (data) {
          var shortdesc;
          for (key in data) {
            if (key.match(/^shortdesc_/)) shortdesc = data[key];
          }
          var getRelatedTopiclist = mainContent.pageRelatedtopics.getObj();
          $(getRelatedTopiclist)
            .find("[data-key='" + mainTopic + "']")
            .after("<br><span>" + shortdesc + "</span>");
        });

        listItems +=
          "<li><a href='" +
          linkBuilder.build(key) +
          "' data-key='" +
          key +
          "'>" +
          productJson[key] +
          "</a></li>";
      }

      var relatedTopics = json.related;
      var listItems = "";
      //console.time("relatedTopics")
      _(relatedTopics).each(createRelatedTopic);
      //console.timeEnd("relatedTopics")
      mainContent.pageRelatedtopics.addItems($(listItems));
      mainContent.pageRelatedtopics
        .getObj()
        .toggleClass("show", !!relatedTopics); // show only if related topics available
    }

    function createPopularTopics(tocJson, key, language) {
      /* WEB-1720: hide ranking
      var getRanking = function (language) {
        var path =
          "data/ranking/" +
          product +
          "-" +
          productVersion +
          "-" +
          language +
          ".json";

        $.getJSON(path)
          .done(function (json) {
            buildList(json);
          })
          .fail(function (jqxhr, textStatus, error) {
            console.error(
              "Ranking Request Failed: " + textStatus + "," + error
            );
            if (language === "en") {
              mainContent.pagePopulartopics.hide();
            } else {
              getRanking("en"); //when no local json available, fallback to english
            }
          });
      };*/

      var buildList = function (rankingJson) {
        var listItems = "";
        var itemsAdded = 0;
        var rankingList = {}; //store the complete id of the topic
        var tempProductJson = _(productJson).omit("toc", tocJson[0]); // this is for popular topics usage
        var maxItemsInList =
          _(tempProductJson).size() > 10 ? 10 : _(tempProductJson).size(); // maximux is 10

        mainContent.pagePopulartopics.clear();

        _(rankingJson).each(function (item, index) {
          //grab complete title for the ranking list topics
          $.each(tempProductJson, function (key, value) {
            if (
              key.indexOf(item.id) > -1 &&
              itemsAdded < maxItemsInList &&
              tocJson[0].indexOf(item.id) === -1
            ) {
              listItems +=
                "<li><a href='" +
                linkBuilder.build(key) +
                "' data-key='" +
                key +
                "'>" +
                tempProductJson[key] +
                "</a></li>";
              rankingList[key] = value;
              itemsAdded++;
              return false; //stop loop when found; no need unnecessary looping
            }
          });
        });

        tempProductJson = _(tempProductJson).omit(function (value, key) {
          //remove ranking topics from product topics json
          return _.chain(rankingList).keys().contains(key).value();
        });

        if (itemsAdded < maxItemsInList) {
          // add balance topics to make the 10 items list
          var balanceTopicsNeeded = maxItemsInList - itemsAdded;
          var allKeys = _(tempProductJson).keys();
          _(balanceTopicsNeeded).times(function (i) {
            listItems +=
              "<li><a href='" +
              linkBuilder.build(allKeys[i]) +
              "' data-key='" +
              allKeys[i] +
              "'>" +
              tempProductJson[allKeys[i]] +
              "</a></li>";
          });
        }

        // /** */ WEB-1720: hide ranking** mainContent.pagePopulartopics.addItems($(listItems));
      };

      var isLandingPage = key === tocJson[0] ? true : false;
      if (isLandingPage) {
        //console.time('popularTopics')
        // **WEB-1720: hide ranking** hide ranking** getRanking(language);
        //console.timeEnd("popularTopics")
      }
      //
      // mainContent.pagePopulartopics;
      //.getObj()
      //.toggleClass("show", !!isLandingPage);
    }

    function createLinking() {
      var $currentLinks = sidebar
        .getObj()
        .find(".current")
        .children("a")
        .parents("li")
        .children("a"); // get parents link but this selector return in reverse

      // Breadcrumb : Refer to setInitialBreadCrumbs for the first 3 links in breadcrumbs.
      // The initial breadcrumbs link should be called only one hence why it is not in this method
      breadcrumb.setBreadcrumbs($($currentLinks.toArray().reverse()), true); //reverse the links list 

      // URL bar
      if (window.history.pushState && !loadFromBrowserHistory) {
        var newUrl = linkBuilder.build(key);
        window.history.pushState(key, productName, newUrl);
      }

      // Pagename/marker for omniture tracking
      // Get selected by using index 0 because it has not been reversed yet
      var sitePath = $currentLinks.length
        ? $($currentLinks[0]).text().toLowerCase().replace(/ /g, "-")
        : "landing"; //replace space with -
      var completePath =
        productLanguage +
        ":" +
        productCategory +
        ":" +
        product +
        ":" +
        productVersion +
        ":" +
        sitePath;
      // Start tracking
      //info : dtmTrack.trackPage(PAGENAME,CATEGORY,LANGUAGE);
      //dtmTrack.trackPage(completePath, productCategory + ":" + product, productLanguage);
    }

    function createDescription(json, $parent) {
      function create(node) {
        function fixImagePaths(content) {
          if (content) {
            var imagePath = "data/" + product + "/pictures/";
            return content.replace(
              'href="pictures\\',
              ' class="img-responsive-inline" src="' + imagePath
            );
          }
          return content;
        }

        function fixCrossReferencePath(content) {
          // Insert ? or tpid param to the link to fix it
          if (content && !location.href.hash) {
            // only applicable if # is not in use
            var matches = content.match(
              /["'](https:\/\/help.f-secure.com\/product\.html#|product\.html#|#)(.*?)["']/g
            );
            //the above will catch URL strings that are in these format (example) :
            // "product.html#the/path/to/the/topic\" or
            // "#the/path/to/the/topic\"
            if (!!matches) {
              //if array not undefined
              matches.forEach(function (val, index) {
                var trim = val.substr(1, val.length - 2); // remove the first " and the last \"
                var hash = trim.split("#")[1].split("/");
                var fixPath =
                  '"' +
                  linkBuilder.bulldProduct(
                    hash[0],
                    hash[1],
                    hash[2],
                    hash[3],
                    hash[4]
                  ) +
                  '"'; //rebuild link
                content = content.replace(val, fixPath);
              });
            }
          }
          return content;
        }

        function cleanUpContent(content) {
          //fix img and path
          content = fixImagePaths(content);
          content = fixCrossReferencePath(content);
          return content;
        }

        function header(key) {
          return key.indexOf(".title_") !== -1;
        }

        function paragraph(key) {
          return key.indexOf(".p_") !== -1;
        }

        function unorderedList(key) {
          return key.indexOf(".ul_") !== -1 || key.indexOf(".choices_") !== -1;
        }

        function orderedList(key) {
          return (
            key.indexOf(".steps_") !== -1 ||
            key.indexOf(".ol_") !== -1 ||
            key.indexOf(".substeps_") !== -1 ||
            key.indexOf(".stepsalpha_") !== -1 ||
            key.indexOf(".substepsalpha_") !== -1 ||
            key.indexOf(".olalpha_") !== -1
          );
        }

        function definitionList(key) {
          return key.indexOf(".dl_") !== -1;
        }

        function note(key) {
          return key.indexOf(".note_") !== -1;
        }

        function table(key) {
          return (
            key.indexOf(".table_") !== -1 ||
            key.indexOf("table.properties") !== -1 ||
            key.indexOf(".choicetable_") !== -1
          );
        }

        function tableHeader(key) {
          return key.indexOf("thead.") !== -1;
        }

        function tableBody(key) {
          return key.indexOf("row.") !== -1;
        }

        function tableCell(key) {
          try {
            return key.indexOf("cell.") !== -1;
          } catch (err) {
            return false;
          }
        }

        function isNotListItem(key) {
          return key.indexOf("content.") !== -1;
        }

        function typeOf(key) {
          if (unorderedList(key)) return "unOrderedList";
          if (note(key)) return "note";
          if (definitionList(key)) return "definitionList";
          if (table(key)) return "table";
          if (orderedList(key)) return "orderedList";
        }

        function buildList($list, key) {
          _(node[key]).each(function (li) {
            var listContent = json[li];
            if (listContent) {
              if (isNotListItem(li)) {
                $list.append(
                  $("<span class='nonlistitem'>").append(create(li))
                );
              } else {
                $list.append($("<li>").html(fixImagePaths(listContent)));
              }
            } else {
              $list.children().last().append(create(li));
            }
          });
          return $list;
        }

        //DCX-383

        function buildNoteDiv($list, key) {
          _(node[key]).each(function (li) {
            var listContent = json[li];
            if (listContent) {
              if (isNotListItem(li)) {
                var notearray = listContent.match(/(.*?):(.*)/);
                var notestructure =
                  "<strong class='font-black'>" + notearray[1] + ":</strong>";
                var notecontent = notestructure + notearray[2];
                $list.append($("<p>").html(fixImagePaths(notecontent)));
              } else {
                $list.append($("<li>").html(fixImagePaths(listContent)));
              }
            } else {
              $list.children().last().append(create(li));
            }
          });
          return $list;
        }

        function buildNote(key) {
          return buildNoteDiv(
            $("<div class='notification notification-warning base-3'>"),
            key
          );
        }

        function buildUnOrderedList(key) {
          return buildList($("<ul>"), key);
        }

        function buildOrderedList(key) {
          var listType =
            key.indexOf("alpha_") !== -1 ? "class='alphabetical'" : "";
          return buildList($("<ol " + listType + ">"), key);
        }

        function buildDefinitionList(key) {
          var $dl = $("<dl class='clearfix'>");
          _(node[key]).each(function (entry) {
            _(entry).each(function (defObj) {
              var $dd = $("<dd>"); //main dd
              _(defObj).each(function (item) {
                if (!_(item).isObject()) {
                  if (item.indexOf(".dt_") !== -1) {
                    var $dt = $("<dt>").html(json[item]);
                    $dl.append($dt);
                  } else {
                    //$dd.append(json[item]);
                    $dd.append(fixCrossReferencePath(json[item]));
                  }
                } else {
                  $dd.append(create(item));
                }
              });
              $dl.append($dd);
            });
          });
          return $dl;
        }

        function buildTable(key) {
          var $table = $("<table>").addClass("table table-hover");
          _(node[key]).each(function (entry) {
            _(entry).each(function (row, key) {
              var $tr = $("<tr>");
              _(row).each(function (cell) {
                var content = cleanUpContent(json[cell]);
                var $cell = tableHeader(_(entry).keys()[0])
                  ? $("<th>")
                  : $("<td>");

                if (!tableCell(cell)) {
                  $cell = $tr.find("td").last();
                }

                if (content) {
                  $cell.html($cell.html() + content);
                } else {
                  $cell.append(create(cell));
                }

                $tr.append($cell);
              });
              $tr = tableHeader(key) ? $("<thead>").append($tr) : $tr;
              $tr = tableBody(key) ? $("<tbody>").append($tr) : $tr;
              $table.append($tr);
            });
          });

          var $rows = $table.find("tr");
          var rowWithMostColumns = _($rows).max(function (row) {
            return $(row).children().length;
          });
          var mostColumns = $(rowWithMostColumns).children().length;

          $table.find("tr").each(function (index, row) {
            var columns = $(row).children().length;
            if (columns < mostColumns) {
              var colspan = mostColumns - columns;
              $(row).children().last().attr("colspan", ++colspan);
            }
          });

          return $table;
        }

        if (_(node).isObject()) {
          var key = _(node).keys()[0];
          switch (typeOf(key)) {
            case "unOrderedList":
              return buildUnOrderedList(key);
            case "note":
              return buildNote(key);
            case "orderedList":
              return buildOrderedList(key);
            case "definitionList":
              return buildDefinitionList(key);
            case "table":
              return buildTable(key);
          }
        } else {
          if (paragraph(node)) {
            return $("<p>").html(cleanUpContent(json[node]));
          } else if (header(node)) {
            return $("<h4>").html(cleanUpContent(json[node]));
          } else if (note(node)) {
            var alertmsg = fixImagePaths(json[node]).split(":");
            alertmsg[0] =
              "<strong class='font-black'>" + alertmsg[0] + "</strong>";
            return $(
              "<div class='notification notification-warning base-3'>"
            ).html(alertmsg.join(":"));
          }
        }
      }
      _(json.desc).each(function (node) {
        if ($parent) {
          $parent.append(create(node));
        } else {
          $("#product-description").append(create(node));
        }
      });
    }

    function createOnePageContent(content, json, $parent) {
      var $originalParent = $parent;

      _(content).each(function (node) {
        if (!_(node).isArray()) {
          var key = _(node).isObject() ? _(node).keys() : node;

          var title = productJson ? productJson[key] : null;
          var $link = $("<h3>").attr("id", key).text(title);

          //short desc
          var subJson = json[key + ".json"];
          var $newShortDesc = $("<p>").html(subJson[subJson.shortdesc]);
          //long desc
          var $newLongDesc = $("<div class='reset'>");
          createDescription(subJson, $newLongDesc);

          var $li = $("<div>").append($link, $newShortDesc, $newLongDesc);
          $li.addClass("indent");
          $parent.append($li);
          $parent = $li;
        }

        if (_(node).isObject()) {
          var $newParent = $parent.is("div") ? $parent : $("<div>");
          //This is a deep loop which affect the browser's performance
          //setTimeout is use to mitigate the issue (gradual append) plus giving the illusion of multithreading
          var pseudothread = setTimeout(function () {
            createOnePageContent(node, json, $newParent);
            clearTimeout(pseudothread);
          }, 500);

          $parent.append($newParent);
        }
        $parent = $originalParent;
      });
    }

    //key 0 always refers to product landing page
    key = key !== 0 ? key : tocJson[0];
    var pathOnePage =
      "data/" +
      product +
      "/all-" +
      productVersion +
      "-" +
      productLanguage +
      ".json"; //path to all topics json
    var pathSpecific = "data/" + product + "/" + key + ".json"; //path to specific topic json
    var path = loadAll ? pathOnePage : pathSpecific;

    omni.loading.show(mainContent.getObj());
    mainContent.clearContent();

    $.getJSON(path)
      .done(function (json) {
        if (loadAll) {
          //execute one page view related stuff
          var tocJsonOp =
            json["toc-" + productVersion + "-" + productLanguage + ".json"];
          var titleID = json[tocJsonOp.toc[0] + ".json"].title;
          var title = json[tocJsonOp.toc[0] + ".json"][titleID];
          var shortDescriptionID = json[tocJsonOp.toc[0] + ".json"].shortdesc;
          var shortDescription =
            json[tocJsonOp.toc[0] + ".json"][shortDescriptionID];

          breadcrumb.clearTrailingCrumbs();
          mainContent.pageTopic.setTopic(title, true);
          mainContent.pageShortDesc.setDesc(shortDescription);
          createDescription(json[tocJsonOp.toc[0] + ".json"]);
          createOnePageContent(
            _(tocJsonOp.toc).rest(),
            json,
            mainContent.pageContentAll.getObj()
          );
        } else {
          //execute specific topic related stuff
          var title = json[json.title];
          var shortDescription = json[json.shortdesc];
          mainContent.pageTopic.setTopic(title);
          mainContent.pageShortDesc.setDesc(shortDescription);
          sidebar.highlightMenuItem(key);
          pageInfo().setPageInfo(title, shortDescription);
          disabledOnePageView();
          createDescription(json);
          createSubTopics(tocJson, key);
          createRelatedTopics(json, key);
          createPopularTopics(tocJson, key, productLanguage);
          createLinking(); 
          omni.updateLanguagesMenuURL();
        }

        omni.loading.remove();
      })
      .fail(function () {
        omni.loading.remove();
        disabledOnePageView();
        mainContent.missingTopicAlert.show();
      });
  }

  function fillInProductVersions(versionJson) {
    function checkLanguageSupport(language) {
      return _(language).where({
        code: productLanguage,
      }).length
        ? true
        : false;
    }

    function setAllVersions(version) {
      var selected =
        productVersion === version.number ? "class='selected'" : "";
      if (!checkLanguageSupport(version.language)) {
        menuItems +=
          "<li " +
          selected +
          "><a href='" +
          linkBuilder.buildCustom(version.number, "en") +
          "'>" +
          version.number +
          " (EN)</a></li>";
      } else {
        menuItems +=
          "<li " +
          selected +
          "><a href='" +
          linkBuilder.buildCustom(version.number, productLanguage) +
          "'>" +
          version.number +
          "</a></li>";
      }
    }

    var menuItems =
      '<li class="dropdown-header m-t-1" data-localize="versionDropdownLabel">Choose Version</li>'; //container
    var sorted = _(versionJson)
      .sortBy(function (obj) {
        return parseFloat(obj.number);
      })
      .reverse();
    _(sorted).map(setAllVersions);

    header.versionMenu.addMenuItems($(menuItems));
  }

  function fillInLanguageSelector(versionJson) {
    function setAllLanguages(language) {
      var selected =
        productLanguage === language.code ? "class='selected'" : "";
        var addLang = productLanguage !== language.code? "' lang='" + language.code : "";
      menuItems +=
        "<li " +
        selected +
        "><a href='" +
        linkBuilder.buildLanguage(language.code) +
        addLang + 
        "' data-code='" +
        language.code +
        "'>" +
        omni.localizeLanguage(language.code, language.name) +
        "</a></li>";
    }

    var menuItems = ""; //container
    var sorted = _(versionJson.language).sortBy("code");
    _(sorted).each(setAllLanguages);

    omni.languageMenus.addMenuItems($(menuItems));
  }

  function fillInPlatforms( 
    topicKey,
    productsJson,
    currentVersion,
    productGroup,
    platformProp, 
  ) {
    function setMenuItem(platformName, path) { 
      var url = path
        ? linkBuilder.bulldProduct(
            productCategory,
            path,
            currentVersion,
            productLanguage
          )
        : window.location.href;
      var selected =
        platformName === platformProp.name ? "class='selected'" : "";
      var menuItem =
        "<li " +
        selected +
        "><a href='" +
        url + "/" + topicKey +
        "' lang='en" +  
        "'>" +
        platformName +
        "</a></li>";
      return menuItem;
    }

    function setPlatforms(product) {
      if (product.platform) {
        var platformName = product.platform.name; 

        var isSupported = _(product.versions).some(function (version) {
          return version.number === currentVersion;
        });

        if (isSupported) {
          menuItems += setMenuItem(platformName, product.path);
        }
      }
    }

    var menuItems = "";
    //console.time("platform")
    if (productGroup && platformProp) {
      var products = _.chain(productsJson)
        .where({
          group: productGroup,
        })
        .sortBy(function (productObj) {
          return productObj.platform ? productObj.platform.name : null;
        });
      _(products).each(setPlatforms); //get multiple menu items
    } else if (!productGroup && platformProp) {
      menuItems = setMenuItem(platformProp.name, platformProp.icon); //set single menu item
    } 
    header.platformMenu.addPlatformMenuItems($(menuItems));
    //console.timeEnd("platform")
  }

  function fillInDoctypes(
    productsJson,
    currentVersion,
    productGroup,
    doctypeProp
  ) {
    function setMenuItem(doctypeName, doctypeHook, path) {
      var url = path
        ? linkBuilder.bulldProduct(
            productCategory,
            path,
            currentVersion,
            productLanguage
          )
        : window.location.href;
      var selected = doctypeName === doctypeProp.name ? "class='selected'" : "";
      var $menuitem =
        "<li " +
        selected +
        "><a href='" +
        url +
        "' data-localize='" +
        doctypeHook +
        "'>" +
        doctypeName +
        "</a></li>";
      return $menuitem;
    }

    function setDoctypes(product) {
      if (product.doctype) {
        var doctypeName = product.doctype.name;
        var doctypeHook = product.doctype.jsHook;
        var isSupported = _(product.versions).some(function (version) {
          return version.number === currentVersion;
        });

        if (isSupported) {
          menuItems += setMenuItem(doctypeName, doctypeHook, product.path);
        }
      }
    }

    var menuItems =
      '<li class="dropdown-header m-t-1" data-localize="doctypeDropdownLabel">Choose Document Type</li>';
    //console.time("doctype")
    if (productGroup && doctypeProp) {
      var products = _.chain(productsJson)
        .where({
          group: productGroup,
        })
        .sortBy(function (productObj) {
          return productObj.doctype ? productObj.doctype.name : null;
        });
      _(products).each(setDoctypes);
    } else if (!productGroup && doctypeProp) {
      menuItems = setMenuItem(doctypeProp.name, doctypeProp.jsHook);
    }
    header.doctypeMenu.addMenuItems($(menuItems));
    //console.timeEnd("doctype")
    localizePage.localize("product:doctype");
  }

  function getLatestVersion() {
    var sorted = _(productVersions)
      .sortBy(function (obj) {
        return parseFloat(obj.number);
      })
      .reverse();
    return sorted[0].number;
  }

  function getSupportedLanguages(versionJson, type) {
    var sortedLangs = _(versionJson.language).sortBy("code");
    if (type === "main" || type === "variant") {
      //e.g : "pt" is main, "pt-br" is variant
      var arrayLength = type === "main" ? 1 : 2; // main lang code will return one array item , variant will return two array items
      return _.chain(sortedLangs)
        .filter(function (val) {
          return val.code.split("-").length === arrayLength;
        })
        .pluck("code")
        .value();
    } else {
      return _(sortedLangs).pluck("code");
    }
  }

  function stripVersionAndLanguage(subPageKey, productVersionObj) {
    function stringExist(key, stringArray, isAtEnd, prefix, suffix) {
      var exist = false;
      var endOfString = isAtEnd ? "$" : "";
      prefix = prefix || "";
      suffix = suffix || "";
      $.each(stringArray, function (index, val) {
        var matcher = new RegExp(prefix + val + suffix + endOfString, "g");
        if (matcher.test(key)) {
          exist = true;
          return false;
        }
      });
      return exist;
    }

    function removeString(key, stringArray, isAtEnd, prefix, suffix) {
      var endOfString = isAtEnd ? "$" : "";
      prefix = prefix || "";
      suffix = suffix || "";
      $.each(stringArray, function (index, val) {
        var matcher = new RegExp(prefix + val + suffix + endOfString, "g");
        if (matcher.test(key)) {
          key = key.replace(matcher, "");
          return false;
        }
      });
      return key;
    }
    //remove languages
    if (
      stringExist(
        subPageKey,
        getSupportedLanguages(productVersionObj, "variant"),
        true,
        "-"
      )
    ) {
      subPageKey = removeString(
        subPageKey,
        getSupportedLanguages(productVersionObj, "variant"),
        true,
        "-"
      );
    } else {
      subPageKey = removeString(
        subPageKey,
        getSupportedLanguages(productVersionObj, "main"),
        true,
        "-"
      );
    }
    //remove version
    if (
      stringExist(subPageKey, [productVersionObj.number, "latest"], false, "-")
    ) {
      subPageKey = removeString(
        subPageKey,
        [productVersionObj.number, "latest"],
        false,
        "-"
      );
    }

    return subPageKey;
  }

  function checkAllTopicsAvailability() {
    //check file availability. If found, disabled one page view toggle

    //disabled if bot detected to avoid getting indexed by search engine
    if (
      !/bot|googlebot|bingbot|crawler|spider|robot|slurp|crawling/i.test(
        navigator.userAgent
      )
    ) {
      var pathOnePage =
        "data/" +
        product +
        "/all-" +
        productVersion +
        "-" +
        productLanguage +
        ".json"; //path to all topics json
      $.ajax({
        url: pathOnePage,
        type: "HEAD",
        cache: false,
        complete: function (jqXHR, status, error) {
          //var contentLength = jqXHR.getResponseHeader('Content-Length');
          //use msg type instead of contentLength to determine file availability since contentlength can be null due to gzip
          //use parsererror as indicator since cloudfront always return 200 even when reach 404
          if (status === "parsererror" || status === "nocontent") {
            //parsererror means file found
            midBar.onePageViewToggle.enabled();
          }
        },
      });
    }
  }

  function showVersionMsgIfOld(productInfo, version) {
    var productID = productInfo.path;
    var ohCookie = {
      cookieName: "fsOHversion",
      products: [],
      cookieExist: function (productID) {
        var cookies = document.cookie.split(";");
        var flag = false;
        var cookieName = this.cookieName;

        if (document.cookie) {
          var fscookie = _.find(cookies, function (ck) {
            return ck.indexOf(cookieName) > -1;
          });

          if (fscookie) {
            var flagRegex = new RegExp("(" + productID + ")+([|]|$)", "g");
            this.products = fscookie.split("=")[1].split("|");
            flag = flagRegex.test(fscookie);
          }
        }

        return flag;
      },
      setCookie: function (productID) {
        var products = this.products;
        products.push(productID);
        var days = 1;
        var exdate = new Date();
        exdate.setTime(exdate.getTime() + days * 24 * 60 * 60 * 1000);
        var cookieValue =
          this.cookieName +
          "=" +
          products.join("|") +
          (";expires=" + exdate.toGMTString());
        document.cookie = cookieValue;
      },
    };

    var closeMsg = function (e) {
      e.preventDefault();
      ohCookie.setCookie(productID);
      $(this).parents()[1].remove();
    };

    //if (!ohCookie.cookieExist(productID) && (version !== productPage.getLatestVersion()) && (urlControl.getURLSymbol() !== "?")) { // ? == bot
    if (
      !ohCookie.cookieExist(productID) &&
      version != productPage.getLatestVersion() &&
      (urlControl.getURLSymbol() === "#" || urlControl.getURLParameter("tpid"))
    ) {
      // ? == bot
      var $verWarning = $(
        "<div class='alert-version'><div class='container'><span class='fsg-icon icon-status-warning'></span><span data-localize='versionMsg'></span></div></div>"
      );
      var $container = $verWarning.children().first();
      var platform = productInfo.platform
        ? " (" + productInfo.platform.name + ")"
        : "";
      var latestVersion = productPage.getLatestVersion();
      var locVersion = uniqVersion.isUniqVersion(latestVersion)
        ? "(<span data-localize='" +
          uniqVersion.getUniqHook(latestVersion) +
          "'>" +
          latestVersion +
          "</span>)"
        : "(" + latestVersion + ")";
      var $url = $("<a>")
        .attr(
          "href",
          linkBuilder.bulldProduct(
            productCategory,
            productID,
            productPage.getLatestVersion(),
            productLanguage
          )
        )
        .html(productName + " " + locVersion + platform);
      var textDefault =
        "This documentation is for an older version of this product. For the product's latest version, click here : ";
      var $closeButton = $(
        "<button aria-label='Close' data-dismiss='alert' class='close base-2' type='button'>"
      ).on("click", closeMsg);
      $container.children("[data-localize='versionMsg']").append(textDefault);
      $container.append($url);
      $container.append($closeButton);
      $("body").prepend($verWarning);
    }
  }

  function buildToc(content, $parent) {
    var ul = function (content) {
      return "<ul>" + content + "</ul>";
    };
    var li = function (content) {
      return "<li>" + content + "</li>";
    };
    var span = function (isParent) {
      return isParent ? "<span class='parent'></span>" : "<span></span>";
    };
    var link = function (key) {
      var linkTitle = productJson !== undefined ? productJson[key] : null;
      return (
        "<a href='" +
        linkBuilder.build(key) +
        "' data-key='" +
        key +
        "'>" +
        linkTitle +
        "</a>"
      );
    };

    var buildList = function (content) {
      var value = "";

      _(content).each(function (node) {
        if (!_(node).isArray()) {
          var key = _(node).isObject() ? _(node).keys() : node;
          if (_(node).isObject()) {
            var UL = ul(buildList(_(node).values()[0]));
            value += li(span(true) + link(key) + UL);
          } else {
            value += li(span() + link(key));
          }
        }
      });
      return value;
    };
    var $newToc = $(buildList(content, $parent));
    $newToc.find(".parent").on("click", sidebar.arrowIconClick);
    $newToc.find("a").on("click", function (e) {
      if (
        urlControl.getURLSymbol() === "#" ||
        urlControl.getURLParameter("tpid")
      ) {
        e.preventDefault();

        sidebar.urlClick($(this));

        if (!isOnePageViewEnabled()) { 
          omni.updatePlatformsMenuURLs($(this).attr("data-key"));
          loadContent($(this).attr("data-key"));  
          utility.moveView();
        } else {
          var target = $(this).data("key");
          var target_offset = $("h3[id='" + target + "']").offset();
          var target_top = target_offset.top;

          if (utility.mqDetector("xs") || utility.mqDetector("sm")) {
            //recalculate position after menu expansion
            var timeout = setTimeout(function () {
              target_offset = $("h3[id='" + target + "']").offset();
              target_top = target_offset.top;
              utility.moveToContent(target_top, false);
              clearTimeout(timeout);
            }, 200);
          } else {
            utility.moveToContent(target_top, false);
          }
        }
      }
    });

    $parent.append($newToc);
  }

  function renderPageContent(productVersion, productSelectedVersionObj) {
    $.getJSON(
      "data/" +
        product +
        "/toc-" +
        productVersion +
        "-" +
        productLanguage +
        ".json"
    )
      .done(function (json) {
        productJson = json;
        tocJson = json.toc;
        //load the default page of the product
        var pageKey = tocJson[0];
        var subPageKey =
          urlControl.getURLParameter("tpid") ||
          window.location.href.split(/[\?\#]/)[1];
        subPageKey = subPageKey.substring(1).split("/")[4];
        if (subPageKey) {
          subPageKey = stripVersionAndLanguage(
            subPageKey,
            productSelectedVersionObj
          );
          subPageKey += "-" + productVersion + "-" + productLanguage;
          pageKey = subPageKey;
        } else {
          //due to bug in ie10, product default page history will be overriden
          try {
            window.history.replaceState(
              pageKey,
              productName,
              window.location.href
            );
          } catch (err) {
            console.error("History API error :" + err);
          }
        }

        checkAllTopicsAvailability(); // if file found, enabled toggle
        buildToc(_(tocJson).rest(), sidebar.getEmptyObj());
        loadContent(pageKey, 0, true);
      })
      .fail(function () {
        redirectPage(); // go to 404
      });
  }

  $.getJSON("data/" + productCategory + "-products.json")
    .done(function (json) {
      var productFound = _(json).findWhere({
        path: product,
      });

      if (productFound === undefined) {
        // Redirect to error page if product not found
        redirectPage(); //go to 404
      } else {
        // Do all the below if product found
        var visiblityOptions = productFound.visibility;
        productName = productFound.name;
        productVersions = productFound.versions;
        productCoveoID = productFound.coveoID;

        /*** TEMPORARY REDIRECT HELP-230 ***/
        // Remove the condition when all Google update all old links to new ones
        var redirectVersion = redirectChecker(product, productVersion);
        if (redirectVersion !== undefined) {
          var timeout = setTimeout(function () {
            //delay the redirection
            document.location.replace(
              linkBuilder.buildCustom(
                redirectVersion.newVersion,
                productLanguage,
                true
              )
            ); //replace version with the actual version
            clearTimeout(timeout);
          }, 500);
        } else if (
          productVersion === "latest" &&
          getLatestVersion() !== "latest"
        ) {
          var timeout = setTimeout(function () {
            //delay the redirection
            document.location.replace(
              linkBuilder.buildCustom(getLatestVersion(), productLanguage, true)
            ); //replace "latest" version with the actual version
            clearTimeout(timeout);
          }, 500);
        } /*** END ***/ else {
          productVersion =
            productVersion === "latest" ? getLatestVersion() : productVersion;

          fillInProductVersions(productFound.versions);
          fillInPlatforms(
            topicKey,
            json,
            productVersion,
            productFound.group,
            productFound.platform
          );
          fillInDoctypes(
            json,
            productVersion,
            productFound.group,
            productFound.doctype
          );

          var productSelectedVersion = _(productFound.versions).findWhere({
            number: productVersion,
          });

          if (productSelectedVersion === undefined) {
            redirectPage(); //go to 404
          }

          var productSelectedLanguage = _(
            productSelectedVersion.language
          ).findWhere({ code: productLanguage });
          fillInLanguageSelector(productSelectedVersion);
          showVersionMsgIfOld(productFound, productVersion);
          renderPageContent(productVersion, productSelectedVersion);

          //switch to the product category theme
          utility.switchTheme(productCategory);

          //set nav url
          navBar.setURLLang(productLanguage);
          navBar.setActive(productCategory);
          navBar.searchForm.setVersion(productVersion);
          navBar.searchForm.setProduct(productCoveoID);
          //end nav url

          //set roundel and produt title
          //header.setProductRoundel(product);
          header.setProductTitle(productName);
          //end roundel and produt title
          //Set version dd ui
          //header.versionMenu.setCurrentValue(productVersion);
          //header.versionMenu.removeIfHidden(visiblityOptions.hideVersion);
          //end version dd ui

          /******************************************************************************************
          Due to unknown issue, the visibility options in product list json (home-products.json or 
          business-products.json) for platform and doctype is using the opposite value to hide the 
          corresponding menu (e.g expected true for hiding, but false was used instead). The two 
          variables below (platformIsHidden and doctypeIsHidden) reverse boolean value so that the 
          same removal method can be used without any modification. The value in json should be 
          corrected so no value reversal needed.
          ******************************************************************************************/

          //Set platform dd ui
          var platfromIsHidden = !!!(
            productFound.platform &&
            visiblityOptions &&
            !visiblityOptions.hidePlatform
          );
          header.platformMenu.setCurrentValue(
            !!productFound.platform
              ? "<img src='img/os/os-" +
                  productFound.platform.icon +
                  ".svg'>" +
                  productFound.platform.name
              : ""
          );
          header.platformMenu.removeIfHidden(platfromIsHidden);
          //end platform dd ui

          //Set doctype dd ui
          var doctypeIsHidden = !!!(
            productFound.doctype &&
            visiblityOptions &&
            !visiblityOptions.hideDoctype
          );
          header.doctypeMenu.setCurrentValue(
            !!productFound.doctype
              ? "<span data-localize='" +
                  productFound.doctype.jsHook +
                  "'>" +
                  productFound.doctype.name +
                  "</span>"
              : ""
          );
          header.doctypeMenu.removeIfHidden(doctypeIsHidden);
          //header.doctypeMenu.addLocalizationHook(!!(productFound.doctype) ? productFound.doctype.jsHook : "none");
          //end doctype dd ui

          //set default selection for language menu
          omni.languageMenus.setCurrentValue(
            omni.localizeLanguage(
              productSelectedLanguage.code,
              productSelectedLanguage.name
            )
          );

          //Set breadcrumb first 3 links
          breadcrumb.setInitialBreadcrumbs(
            productLanguage,
            visiblityOptions.hideVersion,
            productVersion,
            productName,
            productCategory,
            0
          ); // 0 refer to landing page
          //end breadcrumb

          //update the product name for title and meta description
          pageInfo().updateProductName(productName);

          //DCX-106: displayCookieConsent now handled by FS global script
          //showCookieConsent(productLanguage, productCategory);

          //localize strings
          //console.time("localization")
          localizePage.localizeAll("product");
          //console.timeEnd("localization")
        }
      }
    })
    .fail(function () {
      redirectPage(); //go to 404
    });

  return {
    loadPage: loadContent,
    buildToc: buildToc,
    getProductInfo: getProductInfo,
    setProductInfoFromURL: setProductInfoFromURL,
    getProductInfoFromURL: getProductInfoFromURL,
    refreshProductPage: refreshProductPage,
    productCategory: productCategory,
    product: product,
    productVersion: productVersion,
    productLanguage: productLanguage,
    getLatestVersion: getLatestVersion,
    enabledOnePageView: enabledOnePageView,
    disabledOnePageView: disabledOnePageView,
    isOnePageViewEnabled: isOnePageViewEnabled,
    showVersionMsgIfOld: showVersionMsgIfOld,
    menus: {
      fillInProductVersions: fillInProductVersions,
      fillInPlatforms: fillInPlatforms,
      fillInDoctypes: fillInDoctypes,
    },
    set productJSON(json) {
      productJson = json;
      tocJson = json.toc;
    },
  };
})(jQuery);

//old html5 mobile browser fire the popstate during page load which resulting in recurring refresh
//via setTimeout, the popstate will be hold until the initial page loaded.

window.setTimeout(
  function () {
    window.onpopstate = popState;
  },
  500,
  null
);

var popState = function (event) {
  // There are inconsistent support for popstate among older HTML browser especially the mobile browsers.
  // Advisable to use History.js state api instead of relying on the native one.

  if (event.state) {
    if (window.location.hash === "#error") {
      // this is to support older HTML5 mobile browser
      window.history.back();
    }

    var current_product = productPage.getProductInfo().product;
    var current_productVersion = productPage.getProductInfo().productVersion;
    var current_productLanguage = productPage.getProductInfo().productLanguage;
    var current_topicKey = productPage.getProductInfo().topicKey;
    var product_url = productPage.getProductInfoFromURL().product;
    var productVersion_url = productPage.getProductInfoFromURL().productVersion;
    var productLanguage_url = productPage.getProductInfoFromURL().productLanguage;
    var topicKey_url = productPage.getProductInfoFromURL().topicKey;

    //determine that history from same product / avoid unnecessary refresh
    if (current_product === product_url && productVersion_url === "latest") {
      current_productVersion =
        current_productVersion === productPage.getLatestVersion()
          ? "latest"
          : current_productVersion;
    }

    if (
      productVersion_url !== current_productVersion ||
      topicKey_url !== current_topicKey ||
      product_url !== current_product
    ) {
      productPage.setProductInfoFromURL(); // set new info 
      productPage.refreshProductPage();
    } else {
      if (productLanguage_url !== current_productLanguage) {
        productPage.refreshProductPage();
      } else {
        productPage.loadPage(event.state, 0, true);
      }
    }
  } else {
    if (window.location.hash === "#error") {
      // this is to support older HTML5 mobile browser
      window.history.back();
    } else {
      productPage.refreshProductPage(); //load product's first content
    }
  }
};

/*********** UI Controller ************/

var sidebar = (function ($) {
  var $sideBar = $("#sidebar");
  var $sideBarToc = $("#sidebar .toc");
  var $sideBarCollapsible = $("#sidebar .mob-collapsible");
  var $footer = $("#footer");
  var $document = $(document);
  var $window = $(window);
  var tocPos, footPos;
  var bottomOffset = 20;

  var getEmptyObj = function (exception) {
    return !!exception
      ? $sideBarToc.children("li").not(exception).remove()
      : $sideBarToc.empty();
  };

  var getObj = function (exception) {
    return $sideBarToc;
  };

  var clickLink = function ($link) {
    $link.siblings(".parent").addClass("open");
    if (
      (utility.mqDetector("xs") || utility.mqDetector("sm")) &&
      midBar.onePageViewToggle.isActive()
    ) {
      mainContent.pageContentAll.disabledScrollSpy();
    } else {
      $sideBar.removeClass("mob-show");
    }
  };

  var clickParentIcon = function (e) {
    var $target = $(this);
    $target.toggleClass("open", !$target.hasClass("open"));
  };

  var sideBarMaxHeight = function () {
    if (!utility.mqDetector("xs") && !utility.mqDetector("sm")) {
      /*DCX-607: prevent truncated sideBar*/
      /*footPos = $(window).height() + ($(document).scrollTop() - $footer.offset().top);*/
      /*footPos = (footPos < 0) ? 0 : footPos;*/
      tocPos =
        $(window).height() +
        ($(document).scrollTop() -
          $sideBarToc.offset().top) /*- footPos - bottomOffset*/;
      $sideBarToc.css("max-height", tocPos);
    } else {
      $sideBarToc.attr("style", "");
    }
  };

  var highlightMenuItem = function (id) {
    var $currentTopicLink = $sideBarToc.find('a[data-key="' + id + '"]');
    $sideBarToc.find(".current").removeClass("current");
    $sideBarToc.find(".open").removeClass("open");
    $currentTopicLink.parent("li").addClass("current");
    $currentTopicLink.siblings(".parent").addClass("open");
    $currentTopicLink.parents("ul").siblings(".parent").addClass("open");
  };

  var setAffix = function () {
    $document.on("ready scroll mousewheel DOMMouseScroll", sideBarMaxHeight);
    $window.on("load resize", sideBarMaxHeight);

    if ($sideBarToc.length) {
      $sideBarToc.affix({
        offset: {
          top: $sideBarToc.offset().top, //48px padding size
        },
      });
    }
  };

  $sideBarCollapsible.on("click", function (e) {
    $sideBar.toggleClass("mob-show");
  });

  var reInit = function () {
    $sideBarToc = $("#sidebar .toc");
    $footer = $("#footer");
  };

  //init
  setAffix();

  return {
    getEmptyObj: getEmptyObj,
    getObj: getObj,
    arrowIconClick: clickParentIcon,
    urlClick: clickLink,
    highlightMenuItem: highlightMenuItem,
    reInit: reInit,
  };
})(jQuery);

var mainContent = (function ($) {
  var $pageContent = $("#content");
  var $pageTopic = $pageContent.children("h1.product-topic-title");
  var $pageShortDesc = $pageContent.children("#product-short-description");
  var $pageDesc = $pageContent.children("#product-description");
  var $pageSubtopics = $pageContent.children("#product-subtopics");
  var $pageRelatedTopics = $pageContent.children("#product-relatedtopics");
  var $pagePopularTopics = $pageContent.children("#populartopics");
  var $pageContentAll = $pageContent.children("#content-all");
  var $topicMissingAlert = $pageContent.children("#notopic-alert");
  var prevID;

  var list = function ($tgt) {
    var $target = $tgt;

    var clickEvent = function (e) {
      e.preventDefault();
      productPage.loadPage($(this).data("key"));
      utility.moveView();
    };
    var splitColumns = function (totalItem) {
      if (totalItem > 4) {
        $target.children("ul,ol").addClass("split-column-2");
      } else {
        $target.children("ul,ol").removeClass("split-column-2");
      }
    };
    this.getObj = function () {
      return $target;
    };
    this.getEmptyObj = function () {
      return $target.children("ul,ol").empty();
    };
    this.clear = function () {
      $target.children("ul,ol").empty();
    };
    this.addItem = function ($item) {
      //$item : jquery object
      $item.children("a").on("click", clickEvent);
      $target.children("ul,ol").append($item);
      splitColumns($item.siblings().length);
    };
    this.addItems = function ($items) {
      //$items : jquery object
      $items.children("a").on("click", clickEvent);
      $target.children("ul,ol").append($items);
      splitColumns($items.length);
    };
    this.hide = function () {
      $target.removeClass("show");
    };
    this.setTarget = function ($tgt) {
      $target = $tgt;
    };
  };

  var getObj = function () {
    return $pageContent;
  };

  var pageTopic = {
    getObj: function () {
      return $pageTopic;
    },
    setTopic: function (topic, isH1) {
      $pageTopic.html(topic).toggleClass("heading-2", !isH1);
    }, // reverse the value to reduce remove heading-2
    clear: function () {
      $pageTopic.empty();
    },
  };

  var pageShortDesc = {
    getObj: function () {
      return $pageShortDesc;
    },
    setDesc: function (topic) {
      $pageShortDesc.html(topic);
    },
    clear: function () {
      $pageShortDesc.empty();
    },
  };

  var pageDesc = {
    getObj: function () {
      return $pageDesc;
    },
    getEmptyObj: function () {
      return $pageDesc.empty();
    },
    setDesc: function (topic) {
      $pageDesc.html(topic);
    },
    clear: function () {
      $pageDesc.empty();
    },
  };

  var pageSubtopics = new list($pageSubtopics);

  var pageRelatedtopics = new list($pageRelatedTopics);

  var pagePopulartopics = new list($pagePopularTopics);

  var pageContentAll = {
    getObj: function () {
      return $pageContentAll;
    },
    getEmptyObj: function () {
      return $pageContentAll.empty();
    },
    clear: function () {
      $pageContentAll.empty();
    },
    setToc: function ($li) {
      var $ul = $("<ul class='toc'>").append($li);
      $pageContentAll.append($ul);
    },
    enabledScrollSpy: function () {
      $(window).on("scroll", spyScrolling);
    },
    disabledScrollSpy: function () {
      $(window).unbind("scroll", spyScrolling);
    },
  };

  var missingTopicAlert = {
    show: function () {
      $topicMissingAlert.addClass("show");
    },
    hide: function () {
      $topicMissingAlert.removeClass("show");
    },
  };

  var clearContent = function () {
    pageTopic.clear();
    pageShortDesc.clear();
    pageDesc.clear();
    pageSubtopics.clear();
    pageRelatedtopics.clear();
    pagePopulartopics.clear();
    pageContentAll.clear();
    missingTopicAlert.hide();
  };

  var spyScrolling = function (e) {
    var $h3s = $pageContentAll.find("h3");
    var cur = $h3s.map(function () {
      if ($(this).offset().top < $(window).scrollTop() + 100) {
        return this;
      }
    });

    cur = cur[cur.length - 1];
    var id = cur ? $(cur).attr("id") : "";

    if (prevID !== id) {
      sidebar.highlightMenuItem(id);
    }
  };

  var reInit = function () {
    $pageContent = $("#content");
    $pageTopic = $pageContent.children("h1.product-topic-title");
    $pageShortDesc = $pageContent.children("#product-short-description");
    $pageDesc = $pageContent.children("#product-description");
    $pageSubtopics = $pageContent.children("#product-subtopics");
    $pageRelatedTopics = $pageContent.children("#product-relatedtopics");
    $pagePopularTopics = $pageContent.children("#populartopics");
    $pageContentAll = $pageContent.children("#content-all");
    $topicMissingAlert = $pageContent.children("#notopic-alert");
    pageSubtopics.setTarget($pageSubtopics);
    pageRelatedtopics.setTarget($pageRelatedTopics);
  };

  return {
    getObj: getObj,
    pageTopic: pageTopic,
    pageShortDesc: pageShortDesc,
    pageDesc: pageDesc,
    pageSubtopics: pageSubtopics,
    pageRelatedtopics: pageRelatedtopics,
    pagePopulartopics: pagePopulartopics,
    pageContentAll: pageContentAll,
    clearContent: clearContent,
    missingTopicAlert: missingTopicAlert,
    reInit: reInit,
  };
})(jQuery);

var contentAnchor = (function ($) {
  var $contentAnchor = $("#content-anchor");
  $contentAnchor.on("click", function (event) {
    event.preventDefault();
    window.scrollTo(0, 0);
  });

  var checkPosition = function () {
    $contentAnchor.toggleClass("showAnchor", $(window).scrollTop() > 10);
  };

  if ($contentAnchor.length) {
    $(window).on("scroll resize load", checkPosition);
  }
})(jQuery);

var breadcrumb = (function ($) {
  var $breadcrumb = $(".breadcrumb");
  var setInitialBreadcrumbs = function (
    currentLanguage,
    versionIsHidden,
    currentVersion,
    currentProduct,
    productCategory,
    landingID
  ) {
    var initLinks = $breadcrumb.children("li");
    var localizeCategory =
      productCategory === "home"
        ? localizePage.getLocalizedString("common:home") || "All Guides"
        : localizePage.getLocalizedString("common:business") || "All Guides";
    currentVersion = !versionIsHidden ? currentVersion : "";
    var HomeLink = "index.html";

    $(initLinks[0])
      .children("a")
      .attr(
        "href",
        HomeLink + urlControl.getURLSymbol() + "lang=" + currentLanguage
      ); //0 : Home
    $(initLinks[1])
      .children("a")
      .attr(
        "href",
        urlControl.getCategoryPage(productCategory) +
          urlControl.getURLSymbol() +
          "lang=" +
          currentLanguage
      )
      .attr("data-localize", productCategory)
      .text(localizeCategory); //1 : Category Landing
    $(initLinks[2])
      .children("a")
      .text(currentProduct + " " + currentVersion)
      .on("click", function (e) {
        e.preventDefault();
        productPage.loadPage(landingID);
      }); //2 : Product Name
    localizePage.localize("common:home");
  };
  var setBreadcrumbs = function ($links, isCopyEvent) {
    clearCrumbs();
    $links.each(function (index) {
      var $li = $("<li>").append($(this).clone(!!isCopyEvent)); // isCopyEvent true = clone the link and event from toc
      $breadcrumb.append($li);
    });
  };
  var clearCrumbs = function () {
    // Spaces reserved for -> 0:Home Icon  1:Section Name  2:Product Name 3>Topics...
    $breadcrumb.children("li:gt(2)").remove();
  };
  var reInit = function () {
    $breadcrumb = $(".breadcrumb");
  };
  return {
    setInitialBreadcrumbs: setInitialBreadcrumbs,
    setBreadcrumbs: setBreadcrumbs,
    clearTrailingCrumbs: clearCrumbs,
    reInit: reInit,
  };
})(jQuery);

var header = (function ($) { 
  var $productTitle = $(".product-detail h4.product-title"); 
  var $versionmenu = $("#version-menu");
  var $doctypemenu = $("#doctype-menu");
  var $platformmenu = $("#platform-menu");

  var setProductTitle = function (title) {
    $productTitle.text('View topics by platform');
  };

  var versionMenu = new dropdownMenu($versionmenu);
  var doctypeMenu = new dropdownMenu($doctypemenu);
  var platformMenu = new dropdownMenu($platformmenu);

  var reInit = function () { 
    $productTitle = $(".product-detail h4.product-title");
    $versionmenu = $("#version-menu");
    $doctypemenu = $("#doctype-menu");
    $platformmenu = $("#platform-menu");

    versionMenu = new dropdownMenu($versionmenu);
    doctypeMenu = new dropdownMenu($doctypemenu);
    platformMenu = new dropdownMenu($platformmenu);
  };

  return { 
    setProductTitle: setProductTitle,
    versionMenu: versionMenu,
    doctypeMenu: doctypeMenu,
    platformMenu: platformMenu, 
    reInit: reInit,
  };
})(jQuery);

var midBar = (function ($) {
  var $printBtn; // = $("#page-actions .act-print");
  var $emailBtn; // = $("#page-actions .act-email");
  var $onePageViewToggle; // = $("#onepage-toggle");
  var onePageViewToggle;

  var printEvent = function (e) {
    e.preventDefault();
    window.print();
  };

  var emailEvent = function (e) {
    var prodTitle = $(".product-title:first").text();
    var topicTitle = $(".product-topic-title").text();
    var contentBody = "This guide might help you : \n" + window.location.href;
    var url =
      "mailto:?subject=" +
      prodTitle +
      " : " +
      topicTitle +
      "&body=" +
      contentBody;
    document.location.href = url;
  };

  var onePageViewToggleEvent = function (e) {
    e.preventDefault();
    if (!productPage.isOnePageViewEnabled()) {
      var time = setTimeout(function () {
        productPage.enabledOnePageView($(this).data("key"));
        clearTimeout(time);
      }, 500);
    } else {
      productPage.disabledOnePageView(true);
    }
  };

  var init = function () {
    $printBtn = $("#page-actions .act-print").on("click", printEvent);
    $emailBtn = $("#page-actions .act-email").on("click", emailEvent);
    $onePageViewToggle = $("#onepage-toggle");

    onePageViewToggle = {
      getObj: function () {
        return $onePageViewToggle;
      },
      enabled: function () {
        $onePageViewToggle.enabledToggle();
        $onePageViewToggle
          .children(".toggle-button")
          .on("click", onePageViewToggleEvent);
      },
      disabled: function () {
        $onePageViewToggle.disabledToggle();
      },
      switchOff: function () {
        $onePageViewToggle.slideOff();
      },
      isActive: function () {
        return $onePageViewToggle.isToggleActive();
      },
    };
  };

  init();

  return {
    onePageViewToggle: onePageViewToggle,
    reInit: init,
  };
})(jQuery);


var loadQualtricsSurvey = (function () {
  var surveycontainer = document.querySelector(".survey-div");
  var qualtricsSurvey =
  '<script id="survey">(function(){var g=function(e,h,f,g){this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)}};this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};try{(new g(100,"r","QSI_S_ZN_9FxXYDTI7XZw7Q1","https://zn9fxxydti7xzw7q1-fsecure.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_9FxXYDTI7XZw7Q1")).start()}catch(i){}})();</script><div class="survey-div m-t-4"></div>';

  $("#content").append(qualtricsSurvey);
  surveycontainer["id"] = "ZN_9FxXYDTI7XZw7Q1";
})(jQuery);

/************ Unique Component Definition *********/

var toggleSwitch = (function ($) {
  var $toggleSwitches = $(".toggle-switch");
  //	var $toggleButtons = $toggleSwitches.children(".toggle-button");

  var toggleClickEvent = function (e) {
    $(this).parent(".toggle-switch").toggleClass("active");
  };

  $.fn.slideOff = function () {
    if ($(this).has(".toggle-switch")) {
      $(this).removeClass("active");
    }
  };

  $.fn.slideOn = function () {
    if ($(this).has(".toggle-switch")) {
      $(this).addClass("active");
    }
  };

  $.fn.disabledToggle = function () {
    if ($(this).has(".toggle-switch")) {
      $(this).addClass("disabled");
      $(this).children(".toggle-button").unbind("click");
    }
  };

  $.fn.enabledToggle = function () {
    if ($(this).has(".toggle-switch")) {
      $(this).removeClass("disabled");
      $(this).children(".toggle-button").on("click", toggleClickEvent);
      $(this).attr("data-disabled", false);
    }
  };

  $.fn.isToggleActive = function () {
    if ($(this).has(".toggle-switch")) {
      return $(this).hasClass("active");
    }
  };

  var init = function () {
    $toggleSwitches.each(function (index, togSwitch) {
      var $togSwitch = $(togSwitch);
      if (!!$($togSwitch).data("disabled")) {
        $togSwitch.disableToggle();
      } else {
        $togSwitch.enabledToggle();
      }
    });
  };
})(jQuery);

/************ HELP-271: Qualtrics survey reload when browsing content *********/

var lastHash = "";

document.body.addEventListener("click", function (e) {
  if (e.target && e.target.nodeName == "A") {
    hashChangeEventHandler();
  }
});

function reloadQualtrics() {
  QSI.API.unload();
  QSI.API.load().then(QSI.API.run);
}

function hashChangeEventHandler() {
  var newHash = location.hash.split("#")[1];

  if (newHash != lastHash) {
    reloadQualtrics();
    lastHash = newHash;
  }
}

/************ Hide Qualtrics survey in one-page view*********/

(function ($) {
  $("#onepage-toggle").click(function () {
    if ($(this).hasClass("active")) {
      if ("#ZN_9FxXYDTI7XZw7Q1") {
        $("#ZN_9FxXYDTI7XZw7Q1").hide();
      }
    } else {
      if ("#ZN_9FxXYDTI7XZw7Q1") {
        $("#ZN_9FxXYDTI7XZw7Q1").show();
      }
    }
  });
})(jQuery);
